import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, skip, pairwise,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

Dispatch.getAction('StreamInput', 'onChange')
  .pipe(
  )
.subscribe(e => Dispatch.mergeState('StreamInput', { text: e.value }))

Dispatch.getAction('StreamInput', 'onKeyPress')
  .pipe(
    filter(action => action.value === 'Enter'),
    withLatestFrom(Dispatch.getState('StreamInput')),
    map(e => e[1]),
    filter(search => search.text.charAt(0) === '@'),
    withLatestFrom(Dispatch.getState('Tags')),
    // Check if tag exists
    map(([input, tags]) => ({ input, tags, tag: _.find(tags, instance => 
        instance.name === input.text.toLowerCase()) && _.find(tags, instance => 
          instance.name === input.text.toLowerCase())})),
    filter(e => !_.isNil(e.tag)),
    map(e => {
      const input = e.input
      const tags = e.tags
      const tag = e.tag
      return ({...input, text: '', key: Math.random(10000000), tags: { ...input.tags, [tag.id]: tag }})
    }),
    startWith({ tags: {} })
  )
  .subscribe(e => {
    Dispatch.mergeState('StreamInput', e)
  })

Dispatch.getState('Search.tags')
  .pipe(
    // withLatestFrom(Dispatch.getState('StreamInput.tags'))
    // map(([search, stream]) => Object.keys(search).map())
  )
  .subscribe(tags => Dispatch.mergeState('StreamInput.tags', tags))

Dispatch.getAction('StreamInput', 'removeTag')
  .pipe(
    withLatestFrom(Dispatch.getState('StreamInput')),
    map(([remove, inputs]) => {
      var newState = { ...inputs.tags }
      delete newState[remove.tag]
      return ({ ...inputs, tags: newState })
    }),
  )
  .subscribe(e => Dispatch.mergeState('StreamInput', e))

  Dispatch.getAction('StreamInput', 'onKeyPress')
    .pipe(
      filter(e => e.value === 'Enter'),
      withLatestFrom(Dispatch.getState('StreamInput')),
      map(e => e[1]),
      filter(e => (e.text.charAt(0) !== '@' && e.text.charAt(0) !== '#' && e.text !== '')),
    )
    .subscribe(e => {
      Dispatch.mergeState('StreamInput', { text: '', key: Math.random(10000000) })
      Dispatch.nextAction('Instance', 'create', { type: 'text', tags: e.tags, value: e.text })
    })